import { useState } from 'react';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { fetchData } from '../../_lib/lib';
import { checkForSuccesInvocation } from '../../_lib/utils';
import { useConfirm } from '../../context/ConfirmContext';

export interface IProps {
  syncFor: string;
}

const useVerticalSync = ({ syncFor }: IProps) => {
  const { confirm } = useConfirm();
  const [environment, setEnvironment] = useState('');
  const [release, setRelease] = useState('');
  const [processState, setProcessState] = useState<number>(0);
  const [previewState, setPreviewState] = useState<any>(null);
  const [reviewQueriesConfirmationDialog, setReviewQueriesConfirmationDialog] = useState<boolean>(false);
  const [queryData, setQueryData] = useState<any[] | null>(null);
  const { openSnackBar } = useDataService();

  const schemaSync = async () => {
    setProcessState(1);
    const res: any = await fetchData(
      'PATCH',
      `schema-sync${syncFor !== 'master' ? '-slave' : ''}/vertical-sync-v2`,
      {
        body: { environment, release },
      }
    );
    if (!res.error) {
      try {
        checkForSuccesInvocation(res, setPreviewState, setProcessState);
      } catch (e: any) {
        openSnackBar(
          e.message || 'Something went wrong, Unable to check status',
          eMessageType.error
        );
      }
    } else {
      setProcessState(0);
      setPreviewState(null);
      openSnackBar('Vertical Sync Failed', eMessageType.error);
    }
  };

  const openReviewQueriesConfirmationDialog = async () => {
    setReviewQueriesConfirmationDialog(true);
    setQueryData(null);
    const res: any = await fetchData('PATCH', `schema-sync/schema-review-before-sync`, {
      body: { environment, release },
    });
    if (!res.error) {
      const data = Array.isArray(res.queries) ? res.queries : [];
      setQueryData(data);
    } else {
      openSnackBar(res.message || 'Failed to fetch queries', eMessageType.error);
      closeReviewQueriesConfirmationDialog();
    }
  };

  const closeReviewQueriesConfirmationDialog = () => {
    setReviewQueriesConfirmationDialog(false);
    setQueryData(null);
  };

  const onApprove = async () => {
    const res: any = await fetchData('PATCH', `schema-sync/schema-sync-approval`, {
      body: { environment, release },
    });
    if (!res.error) {
      openSnackBar(res.message.toUpperCase() || 'QUERIES APPROVED SUCCESSFULLY', eMessageType.success);
    } else {
      openSnackBar(res.message.toUpperCase() || 'APPROVE QUERIES FAILED', eMessageType.error);
    }
  };

  return {
    environment,
    setEnvironment,
    release,
    setRelease,
    processState,
    setProcessState,
    previewState,
    reviewQueriesConfirmationDialog,
    queryData,
    schemaSync,
    openReviewQueriesConfirmationDialog,
    closeReviewQueriesConfirmationDialog,
    onApprove,
    confirm,
  };
};

export default useVerticalSync;
